import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type SignUpQuestions = {
  showModal: boolean
  questions: SignUpFilterQuestion[]
  selectedQuestions: SelectedSignUpQuestions[]
  savedQuestions: SignUpFilterQuestion[]
}

const initialState: SignUpQuestions = {
  showModal: false,
  questions: [],
  selectedQuestions: [],
  savedQuestions: [],
}

export const signUpQuestions = createSlice({
  name: 'signUpFormFilter',
  initialState,
  reducers: {
    toggleModal(state) {
      state.showModal = !state.showModal
    },
    updateQuestions(state, action: PayloadAction<SignUpFilterQuestion[]>) {
      state.questions = action.payload
    },
    updateSelectedQuestions(
      state,
      action: PayloadAction<SelectedSignUpQuestions[]>,
    ) {
      state.selectedQuestions = action.payload
    },
    saveQuestions(state) {
      state.savedQuestions = state.questions
    },
    revertToSavedQuestions(state) {
      if (state.savedQuestions.length) state.questions = state.savedQuestions
    },
    resetQuestions(state) {
      const questionsWithResetValue = state.questions.map((question) => {
        return {
          ...question,
          value: [],
        }
      })

      state.questions = questionsWithResetValue
      state.selectedQuestions = []
      state.savedQuestions = []
    },
  },
})

export const {
  toggleModal,
  updateQuestions,
  updateSelectedQuestions,
  resetQuestions,
  saveQuestions,
  revertToSavedQuestions,
} = signUpQuestions.actions
export default signUpQuestions.reducer
